import styled from 'styled-components';
import { Card } from '@veneer/core';
import primitives from '@veneer/primitives';
import { mixins } from '@jarvis/react-portal-addons';

export const CardBody = styled(Card)`
  && {
    grid-column: span 4;
    border: 1px solid ${({ theme }) => theme.color.stroke.decorative.default};
    grid-column: span 12;
    width: 100%;

    ${mixins.veneer.md(`
      grid-column: span 6;
    `)}

    ${mixins.veneer.xl(`
      grid-column: span 4;
    `)}

  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mixins.veneer.xs(`
    width: 100%;
  `)}
`;

export const HeaderContainer = styled.div`
  height: 84px;
  display: flex;
  align-items: center;
  padding-left: ${primitives.layout.size6}px;
  border-bottom: 1px solid ${primitives.color.gray3};
  box-sizing: border-box;
`;

export const HeaderText = styled.h2`
  text-align: center;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
